export default {
      id: "ic_tiktok-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic_tiktok-usage",
      toString: function () {
        return this.url;
      }
    }